<template>
	<div class="item" @click="viewAnswer">
		<img class="cover" :src="value.url" alt="无法加载" />
		
		<div class="title ellipsis" v-if="value.name">
			{{ value.name }} {{ value.subjectName || '' }}
		</div>
		
		<div>
			<div class="text ellipsis mb-5">
				{{ value.standardName || '' }}
			</div>
			
			<div class="text ellipsis">
				{{ value.phaseName || '' }}
			</div>
		</div>
	</div>
</template>

<script>

	export default {
		props: {
			value: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				
			}
		},
		methods: {
			viewAnswer () {
				if (!this.value?.answerUrl) return this.$message.warning("当前教辅暂无可查看答案")
				this.$emit('change', this.value)
			}
		}
	}
</script>

<style lang="less" scoped>
	.item{
		padding: 10px;
		background-color: #F2F2F2;
		border-radius: 6px;
		margin-bottom: 10px;
	}
	.cover{
		width: 100%;
		height: 200px;
		margin-bottom: 5px;
	}
	.title{
		font-size: 14px;
		color: #333;
		font-weight: bold;
	}
	.text{
		font-size: 12px;
		color: #7F7F7F;
	}
	.mb-5{
		margin: 2px 0;
	}
	.btn{
		font-size: 11px;
		padding: 2px 10px;
		border-radius: 12rpx;
		border: 1px solid #08ACC1;
		color: #08ACC1;
		background-color: rgba(8,172,193,.3);
	}
</style>
